import { ApplicationSettingsEffects } from './store/application-settings.effects'
import { EffectsModule } from '@ngrx/effects'
import { NgModule } from '@angular/core'

@NgModule({ imports: [EffectsModule.forFeature([ApplicationSettingsEffects])] })
export class ApplicationSettingsNgrxModule {}
